import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';

export const SortBarStyles = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .sort-opt-container {
    width: 180px;
  }
  .dropdown-selected-text {
    font-weight: normal;
    font-family: 'source-sans-pro';
  }
  .dropdown-list {
    width: 155px;

    button {
      cursor: pointer;
    }
  }

  .sort-options {
    padding-bottom: 20px;
  }

  .sort-by {
    .modal-window {
      left: -120px;
    }
    > button:before {
      content: '${(props) => props.sortText}';
      font-size: 12px;
      font-weight: bold;
      color: ${Colors.primary.claytonBlue.standard};
    }
  }

  .sorting-by-chevron {
    fill: ${Colors.primary.claytonBlue.standard};
    position: relative;
    top: 4px;
  }

  .sort-button {
    background-color: #fff;
    border: solid 1px ${Colors.accent.grey4.standard};
    border: hidden;
    /* margin: 5px; */
    padding: 0 3px;

    &.active {
      color: ${Colors.primary.claytonBlue.standard};
      border-color: ${Colors.primary.claytonBlue.standard};
    }
    &.changed {
      background-color: ${Colors.primary.claytonBlue.standard};
      color: #fff;
    }
    &:hover {
      cursor: pointer;
      color: ${Colors.primary.claytonBlue.hover};
    }
  }

  .sort-options-label {
    display: inline;
  }
`;
